import { DeviceTypes } from '@eppendorf/app-configs';

const REPORT_SUPPORTED_DEVICE_TYPES: DeviceTypes[] = [
  DeviceTypes.FREEZER,
  DeviceTypes.INCUBATOR,
  DeviceTypes.MONITOR,
];

export function canCreateReport(deviceType: string | undefined): boolean {
  return REPORT_SUPPORTED_DEVICE_TYPES.includes(deviceType as DeviceTypes);
}
